// frontend/src/components/calendar/CalendarToolbar.js
import React from 'react';
import {
    Box,
    Typography,
    IconButton,
    Button,
    ToggleButtonGroup,
    ToggleButton,
    Chip,
    Stack
} from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import YouTubeIcon from '@mui/icons-material/YouTube';
import InstagramIcon from '@mui/icons-material/Instagram';
import TwitterIcon from '@mui/icons-material/Twitter';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import FacebookIcon from '@mui/icons-material/Facebook';
import RedditIcon from '@mui/icons-material/Reddit';
import { PLATFORM_COLORS } from './CALENDAR_CONFIG';

const PLATFORMS = [
    { id: 'youtube', label: 'YT', icon: YouTubeIcon },
    { id: 'instagram', label: 'IG', icon: InstagramIcon },
    { id: 'twitter', label: 'TW', icon: TwitterIcon },
    { id: 'linkedin', label: 'LI', icon: LinkedInIcon },
    { id: 'facebook', label: 'FB', icon: FacebookIcon },
    { id: 'reddit', label: 'RD', icon: RedditIcon },
];

const CalendarToolbar = (props) => {
    const {
        label,
        onNavigate,
        onView,
        view,
        activePlatforms,
        onPlatformToggle
    } = props;

    return (
        <Box data-testid="calendar-toolbar" sx={{ mb: 3 }}>
            <Stack
                direction={{ xs: 'column', md: 'row' }}
                justifyContent="space-between"
                alignItems="center"
                spacing={2}
                sx={{ mb: 2 }}
            >
                <Stack direction="row" alignItems="center" spacing={1}>
                    <IconButton onClick={() => onNavigate('PREV')} data-testid="nav-prev">
                        <ChevronLeftIcon />
                    </IconButton>
                    <Button
                        variant="outlined"
                        size="small"
                        onClick={() => onNavigate('TODAY')}
                        data-testid="nav-today"
                        sx={{ borderRadius: 8 }}
                    >
                        Today
                    </Button>
                    <IconButton onClick={() => onNavigate('NEXT')} data-testid="nav-next">
                        <ChevronRightIcon />
                    </IconButton>

                    <Typography variant="h5" fontWeight="bold" data-testid="calendar-month-label" sx={{ ml: 2 }}>
                        {label}
                    </Typography>
                </Stack>

                <ToggleButtonGroup
                    value={view}
                    exclusive
                    onChange={(e, nextView) => nextView && onView(nextView)}
                    size="small"
                    sx={{ bgcolor: 'background.paper', borderRadius: 2 }}
                >
                    <ToggleButton value="month" data-testid="view-month" sx={{ px: 2 }}>Month</ToggleButton>
                    <ToggleButton value="week" data-testid="view-week" sx={{ px: 2 }}>Week</ToggleButton>
                    <ToggleButton value="day" data-testid="view-day" sx={{ px: 2 }}>Day</ToggleButton>
                </ToggleButtonGroup>
            </Stack>

            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, alignItems: 'center' }}>
                <Typography variant="body2" color="text.secondary" sx={{ mr: 1 }}>Filter:</Typography>
                <Chip
                    label="All"
                    onClick={() => onPlatformToggle(null)}
                    color={activePlatforms.length === 0 ? 'primary' : 'default'}
                    variant={activePlatforms.length === 0 ? 'filled' : 'outlined'}
                    size="small"
                    data-testid="platform-filter-all"
                />
                {PLATFORMS.map((p) => {
                    const isActive = activePlatforms.includes(p.id);
                    const Icon = p.icon;
                    return (
                        <Chip
                            key={p.id}
                            icon={<Icon style={{ fontSize: 16, color: isActive ? 'white' : PLATFORM_COLORS[p.id] }} />}
                            label={p.label}
                            onClick={() => onPlatformToggle(p.id)}
                            variant={isActive ? 'filled' : 'outlined'}
                            size="small"
                            data-testid={`platform-filter-${p.id}`}
                            sx={{
                                ...(isActive && {
                                    bgcolor: PLATFORM_COLORS[p.id],
                                    '&:hover': { bgcolor: PLATFORM_COLORS[p.id], opacity: 0.9 },
                                })
                            }}
                        />
                    );
                })}
            </Box>
        </Box>
    );
};

export default CalendarToolbar;
